import "./tablestyles.scss";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridRowProps,
  GridNoRecords
} from "@progress/kendo-react-grid";
// import { DropDown } from "./myDropDown";
import ButtonDefault from "../button";
import { useEffect, useState } from "react";
// import { getAPI } from "../../api";
// import { Resources } from './interfaces'
// import { getter } from '@progress/kendo-react-common';
import { useNavigate } from "react-router-dom";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { checkAvailability, getMilliSec, getMilliSecUTC } from "../../utils/ellowutils";
import * as CONSTANTS from '../../utils/CONSTANTS'
import ContractDetails from "../../modal/contractDetails";
import { getPositionsDetails ,  updatePositionStatus, contractMetadata } from "./services";
import { orderBy, SortDescriptor } from "@progress/kendo-data-query";
import { Icon } from '@iconify/react';
import mixpanelData from "../../utils/mixpanel";


const { v4: uuidv4 } = require("uuid");
const userLoginId = localStorage.getItem('loginId')

const AppliedResourcesTable = (props: any) => {
  
  let jobId = props.jobId
  const navigate = useNavigate()
  
  const [allocatedTo, setAllocatedTo] = useState<any>();
  const [contractLoginId, setContractLoginId] = useState<any>('')
  const [contractDetails, setContractDetails] = useState<any>(false);
  const [contractDefaultData, setContractDefaultData] = useState<any>()
  const [contract, setContract] = useState<boolean>(false)
  const [ellowRate , setEllowRate]= useState<any>()
  const [currencyType , setCurrencyType] =useState<any>()
  const [billingType , setBillingType] = useState<any>()
  const initialSort: Array<SortDescriptor> = [
    { field: "name", dir: "asc" },
  ];

  const [sort, setSort] = useState(initialSort);

  useEffect(() => { 
    // getAllocatedto().then((response) => {
    //   if (response && response.status === 1) {
    //     setAllocatedTo(
    //       response.data.map((item: any) => {
    //         return item.name;
    //       })
    //     )
    //   }
    // })
  }, [])
  


  const skillsCell = (props: GridCellProps) => {

    let length = props.dataItem.skills && props.dataItem.skills.length;

    return (
      <td >
         <div className="skillsWrap">
          {props.dataItem.skills && props.dataItem.skills.map((item: string, key: number)  => {
             return ((item) +  (key < length-1 ?     ' , ' : ''))          })}
        </div>
      </td>
    );
  };
  const signInDateCell = (props: GridCellProps) => {
    let signindate =props.dataItem.contractMetadata && props.dataItem.contractMetadata.signInDate ? new Date(props.dataItem.contractMetadata && props.dataItem.contractMetadata.signInDate).toDateString():"";
    return <td>{signindate}</td>;
  };
const rowClick = (e: any) => {
   props.rowClick(e)
  }
  



  const dateCell = (props: GridCellProps) => {
    let dateNumber = parseInt(props.dataItem.dateOfRegistration);
    let date = new Date(dateNumber).toDateString();

    return <td><div className="dateWrap">{date}</div></td>;
  };

  const experienceCell = (props: GridCellProps) => {
    return <td>{props.dataItem.experience + " Years"}</td>;
  };

  const ellowrateCell = (props: GridCellProps) => {
    return <td>{props.dataItem.positionEllowRate + " "+props.dataItem.positionCurrencyType +" / "+props.dataItem.positionBillingType}</td>;
  };

  const resourcecostCell = (props: GridCellProps) => {
    return <td>{props.dataItem.rates !== null ? + props.dataItem.rates : 'Not Mentioned'}</td>;
  };

  const viewButton = (Props: GridCellProps) => {  
    return (
      <td>
        {Props.dataItem.positionStatus === "Resource Accepted Offer" && <button type="button" className="applyButton" onClick={(e: any) => { setContractLoginId(Props.dataItem.loginId); setContractDetails(true); setContractDefaultData(Props.dataItem.contractMetadata);}}>
          Contract Details</button>}
      </td>
    );
  };

  const availablityCell = (props: GridCellProps) => {    
    return (
      <td>
        {checkAvailability(props.dataItem.availabilityValue)}
      </td>
    )
  }

  const updatePositionStatusFunction = (value: any) => {
    updatePositionStatus(value).then((response: any) => {
      if (response.status === 1) {
        if (value.positionStatus === 3) {
          mixpanelData('New MT - Profile rejected', {
            'distinct_id': localStorage.getItem('Email'),
            'Candidate loginId': value.candidateId,
            'Company id': localStorage.getItem('customerId'),
            "Job id": value.jobId,
            "Job title":response && response.data[0].jobTitle,
            "Company name": response && response.data[0].companyName,
            "Candidate email": response && response.data[0].candidateEmail,
            "Candidate name": response && response.data[0].candidateName,
            "Position status": "Rejected"
          })
        }
        if (value.positionStatus === 2) {
          mixpanelData('New MT - Profile shortlisted', {
            'distinct_id': localStorage.getItem('Email'),
            'Candidate loginId': value.candidateId,
            'Company id': localStorage.getItem('customerId'),
            "Job id": value.jobId,
            "Job title":response && response.data[0].jobTitle,
            "Company name": response && response.data[0].companyName,
            "Candidate email": response && response.data[0].candidateEmail,
            "Candidate name": response && response.data[0].candidateName,
            "Position status": "Shortlisted"
          })
        }
        getTableValues()
        getPositionsDetails(jobId)
      }
    })
  }
 
  const submitContractDetails = (data: any) => {
    
   let contractValues = {
    "jobId":props.jobId,
     "candidateId": contractLoginId,
     "historyFlag": data.history,
     'submittedBy': 'CUSTOMER',
      "contractMetadata":{
        "contractId": contractDefaultData && contractDefaultData.contractId ? contractDefaultData.contractId : uuidv4(),
        "contractStartDate":data.startDate,
        "contractEndDate":data.endDate,
        "duration":data.duration,
        // "contractRate":data.contractRate,
        "ellowCurrencyType":data.ellowCurrencyType,
        "ellowBillingType":data.ellowBillingType,
        "closedBy":data.closedBy,
        "ellowRate":parseInt(data.ellowRate),
        "supportingDoc": data.supportingDoc,
        "skills":data.skills,
        "inContract":true,
        "createdOn":getMilliSecUTC(new Date()),
      "updatedOn": getMilliSecUTC(new Date()), 
      }
    }
    contractMetadata(contractValues).then((response: any) => {
      if (response && response.status === 1) {
          
        setContractDetails(false)

        let value = {
          "candidateId": contractLoginId,
          "userLoginId": userLoginId,
          "jobId":jobId,
          "positionStatus":5
        }
        updatePositionStatusFunction(value)

        }
      
    })
     
  }

  const positionStatusDropdown = (props: GridCellProps, getTableValues: any) => {
    const { dataItem } = props;
    const field = props.field || '';

    const dataValue = dataItem[field] === null ? '' : (dataItem[field] === "Rejected by Hirer" ? "Rejected" : dataItem[field]);
    const handleChange = (e: DropDownListChangeEvent) => {
        let value = {
        "candidateId": props.dataItem.loginId,
        "userLoginId": userLoginId,
        "jobId":jobId,
        "positionStatus":e.target.value.id 
        }
        updatePositionStatusFunction(value)
    }

    return (
      <td>
        { dataItem && dataItem.positionStatus !== 'Resource Accepted Offer' && dataItem.inEdit ? (
          <DropDownList
            style={{ width: "100%" }}
            data={CONSTANTS.positionStatuswithId}
            onChange={handleChange}
            dataItemKey='id'
            textField="name"
          />
      ) :(dataValue)  }
      </td>
    )
  }

  const getTableValues = () => {
    props.getTables()
  }

  const redirection = (candidateLoginId: string) => {
    navigate('../preview', { state: { candidateLoginId: candidateLoginId}})
  }

  return (
    <div className='tableStyle no-top-padd no-min-height tableMaxHeight'>
    <Grid
        data={orderBy(props.state.items,sort)}
        onPageChange={props.pageChange}
      // total={props.total}
      // skip={props.state.skip}
      // pageable={props.state.pageable}
      // pageSize={props.state.pageSize}
      // onItemChange={props.itemChange}
        onRowClick={(e) => rowClick(e)}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
        }}
    >
      <GridNoRecords>
            <div className="noData">
              <Icon icon="mdi:smiley-neutral-outline" />
              No data to display
            </div>
          </GridNoRecords>
      <Column field="name" title="Name" className="pointer" cell={(props: GridCellProps) => nameCell(props, (candidateLoginId: string) => redirection(candidateLoginId))}/>
      <Column field="Skills" title="Skills" cell={skillsCell} />
      <Column field="experience" title="Experience" cell={experienceCell} />
      {/* <Column field="ellowStatus" title="ellow status" cell={(props:GridCellProps) => ellowStatusDropdown(props,() => getTableValues() )} /> */}
      <Column field="ellowStatus" title="ellow Status"/>
      <Column field="availabilityValue" title="Availability" cell={availablityCell} />
      <Column field="positionEllowRate" title="ellow Rate" cell={ellowrateCell} />
      <Column field="positionStatus" title="Position Status"  cell={(props: GridCellProps) =>positionStatusDropdown(props, () => getTableValues())}/>
      <Column field="signInDate" title="Sign In Date"  cell={signInDateCell}/>
      <Column cell={viewButton} />
      </Grid>
      {contractDetails && <ContractDetails onClose={() => setContractDetails(false)} allocatedTo={allocatedTo} ClickHandler={submitContractDetails} defaultvalues={contractDefaultData} ellowRate={ellowRate} currencyType={currencyType} billingType={billingType}/>}
    </div>
  );
};

export default AppliedResourcesTable;

const nameCell = (props: GridCellProps, redirection: any) => {
  
  const profileImage = props.dataItem.googleProfileImage ?  props.dataItem.googleProfileImage : " " 
  
  return (
    <td>
      <div className="userInfo no-height" onClick={() => redirection(props.dataItem.loginId)}>
          {profileImage === " "? 
           <figure>{props.dataItem && props.dataItem.firstName && props.dataItem.firstName[0]}{props.dataItem && props.dataItem.lastName && props.dataItem.lastName[0]}</figure>
          :
          <figure><img src={ profileImage }></img></figure> }
          {props.dataItem.name}
      </div>
    </td>
  )
}
